/* V218 — Hero copy A/B test client helpers.
 *
 * Sticky variant assignment via localStorage (30-day TTL).
 * Variants: A (current), B, C, D — each at 25% weight.
 * Translations keys map: A → hero_question, B → hero_question_b, ...
 */
import axios from "axios";
import { API } from "../config";

const STORAGE_KEY = "trp_hero_ab_v1";
const VISITOR_KEY = "trp_hero_ab_visitor";
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
const VARIANTS = ["A", "B", "C", "D"];
const TRANSLATION_KEY_MAP = {
  A: "hero_question",
  B: "hero_question_b",
  C: "hero_question_c",
  D: "hero_question_d",
};

function safeGet() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !VARIANTS.includes(parsed.variant)) return null;
    if (typeof parsed.assigned_at !== "number") return null;
    if (Date.now() - parsed.assigned_at > TTL_MS) return null;
    return parsed;
  } catch {
    return null;
  }
}

function safeSet(variant) {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ variant, assigned_at: Date.now() })
    );
  } catch {
    /* ignore quota errors */
  }
}

function getVisitorId() {
  try {
    let v = localStorage.getItem(VISITOR_KEY);
    if (!v) {
      v =
        (typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID()) ||
        `v_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
      localStorage.setItem(VISITOR_KEY, v);
    }
    return v;
  } catch {
    return null;
  }
}

export function getHeroVariant() {
  const cached = safeGet();
  if (cached) return cached.variant;
  const v = VARIANTS[Math.floor(Math.random() * VARIANTS.length)];
  safeSet(v);
  return v;
}

export function getHeroQuestionKey(variant) {
  return TRANSLATION_KEY_MAP[variant] || "hero_question";
}

export function getHeroQuestionText(t, variant) {
  const key = getHeroQuestionKey(variant);
  return t[key] || t.hero_question || "Is yours?";
}

const sentImpression = new Set();

export function trackHeroEvent(event, variant, language) {
  if (!variant || !event) return;
  // Dedupe impressions per session per variant.
  if (event === "impression") {
    const k = `imp:${variant}:${language || ""}`;
    if (sentImpression.has(k)) return;
    sentImpression.add(k);
  }
  try {
    axios.post(
      `${API}/hero-ab/event`,
      {
        variant,
        event,
        language: language || "sk",
        visitor_id: getVisitorId(),
      },
      { timeout: 8000 }
    ).catch(() => { /* fire-and-forget */ });
  } catch {
    /* ignore */
  }
}
